import * as React from "react";
import {Link} from "react-router-dom";
import "./styles.scss";
import Loading from "components/loading";

interface IProps {
  loading: boolean;
  pathname: string;
}
export default class Layout extends React.Component<IProps, {}> {
  constructor(props) {
    super(props);
  }
  public render() {
    return (
      <div className="container-fluid d-flex justify-content-center main-container">
        <Loading
         active={this.props.loading}/>
        <div className="container layout-remove-padding">
            {this.props.pathname && <div className="col-md-6 offset-md-3 layout-remove-padding">
              <Link className="go-back-link pt-4" to={this.props.pathname}>
                  <div className="go-back-incomplete">
                    <i className="fa fa-angle-left arrow-back-application"/>
                      Go back to application
                  </div>
              </Link>
            </div>}
            <br></br>
            <div className="layour-box-shadow">
             {this.props.children}
            </div>
        </div>
      </div>
    );
  }
}
